import {HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {throwError} from 'rxjs';
import {ApiErrorSnackbarService} from '../services/api-error-snackbar.service';
import {catchError} from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly snackbarService: ApiErrorSnackbarService = inject(ApiErrorSnackbarService);

  private endpointsToIgnoreError = [
    {url: '/screening-settings', method: 'GET'},
    {url: '/project/info', method: 'GET'},
    {url: '/summary/', method: 'GET'},
  ];


  intercept(request: HttpRequest<any>, next: HttpHandler) {
    const shouldIgnoreError = this.endpointsToIgnoreError.some(
      (endpoint) => request.url.includes(endpoint.url) && request.method === endpoint.method
    );

    return next.handle(request).pipe(
      catchError((err) => {
        if (!shouldIgnoreError) {
          this.snackbarService.showSnackBar(err, `General Error`);
        }
        return throwError(() => err);
      })
    );
  }
}
